<template>
  <!-- <div> -->
  <!-- <breadcrumb :items="breadcrumbs"></breadcrumb> -->
  <!-- <v-container fluid> -->
  <!-- <farm-info :id="$route.params.farmId" /> -->
  <v-dialog max-width="500" v-model="newdialog">
    <!-- <div class="registration-section"> -->
    <!-- <div class="main-register">
            <div class="registration-heading">
              <h2>Product Registration</h2>
            </div>
          </div> -->
    <v-card>
      <v-toolbar color="secondary" dark>
        <v-row>
          <v-col cols="11">Product Registration</v-col>
          <v-col cols="1">
            <v-icon @click="unset(false)">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="registerProduct"
      >
        <v-card-text>
          <v-row class="pa-5">
            <v-col cols="12"></v-col>
            <v-col lg="12" md="4" sm="6" xs="6">
              <div class="form-group">
                <div class="cell-2">
                  <label for="text"
                    >Product Name <span>*</span>

                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Enter the name of the product</span>
                    </v-tooltip>
                  </label>
                </div>
                <v-text-field
                  v-model="prodToAdd.name"
                  placeholder="Name Of The Product"
                  outlined
                  dense
                  :rules="productRules.name"
                ></v-text-field>
              </div>
            </v-col>
            <v-col lg="12" md="4" sm="6" xs="6">
              <div class="form-group">
                <label for="text">In Stock <span>*</span></label>
                <v-layout row>
                  <v-col cols="col">
                    <v-text-field
                      type="number"
                      placeholder="Product Quantity"
                      outlined
                      dense
                      v-model="prodToAdd.stockQty"
                      :rules="productRules.stockQty"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="col">
                    <v-select
                      :items="perUni"
                      placeholder="Select Unit"
                      outlined
                      dense
                      v-model="prodToAdd.stockUom"
                      :rules="productRules.stockUom"
                    ></v-select>
                  </v-col>
                </v-layout>
              </div>
            </v-col>
            <v-col lg="12" md="4" sm="4" xs="6">
              <div class="form-group">
                <label for="text">Product Category <span>*</span></label>
                <v-select
                  :items="category"
                  v-model="prodToAdd.productCategoriesOptId"
                  placeholder="Select Category"
                  item-value="id"
                  item-text="name"
                  outlined
                  dense
                  :rules="productRules.productCategory"
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="mx-auto mb-4" style="width: 95%"></v-divider>
        <v-card-actions class="justify-end">
          <v-btn class="px-8 mb-4" outlined color="primary" @click="unset(false)">Cancel</v-btn>
          <v-btn class="px-8 mb-4" @click="unset(false)" type="submit" color="primary"
            >Submit</v-btn
          >
        </v-card-actions>
        <!-- <div class="">
            <v-btn
              width="146"
              class="mr-2"
              outlined
              color="primary"
              :to="{ name: 'FarmProducts' }"
              >Cancel</v-btn
            >
            <v-btn width="146" type="submit" color="primary">Submit</v-btn>
          </div> -->
      </v-form>
    </v-card>
    <!-- </div> -->
  </v-dialog>
  <!-- </v-container>
  </div> -->
</template>

<script>
// import Breadcrumb from "@/components/core/Breadcrumb";
import loadingMixin from "@/mixins/LoadingMixin";
// import FarmInfo from "./FarmInfo.vue";
import NtrService from "@/_services/NtrService";
import { productRules } from "@/validations/ProductRules.js";
import GeneralService from "@/_services/GeneralService";
export default {
  name: "RegisterProduct",
  // components: {
  //   breadcrumb: Breadcrumb,
  //   FarmInfo,
  // },
  mounted() {
    this.loadOptions();
  },
  updated() {
    console.log(this.props.newDialog, 'fsfsfsfsd')
  },
  data() {
    return {
      prodToAdd: {},
      productRules,
      valid: true,
      category: [],
      perUni: ["kg"],
    };
  },
  methods: {
    loadOptions() {
      const options = {
        options: ["product-categories"],
      };
      GeneralService.getDropdownData(options).then((data) => {
        this.category = data.data["product-categories"];
        console.log(this.category);
      });
    },
    registerProduct() {
      if (!this.$refs.form.validate()) return;
      this.startLoading();
      this.prodToAdd.farmNumber = this.id;
      console.log("res", this.prodToAdd);
      NtrService.addProd(this.prodToAdd)
        .then((res) => {
          if (res.success) {
            this.$notify({
              title: "Product Added",
              text: res.message,
              type: "success",
            });
            this.prodToAdd = {};
            this.$refs.form.reset();
            this.getInfo();
          } else {
            this.$notify({
              title: "Product not Added",
              text: res.message,
              type: "error",
            });
          }
          this.stopLoading();
        })
        .catch((error) => {
          if (error.status == 422) {
            error.data.message.errors.forEach((err) => {
              console.log(err.param + " -- " + err.msg);
              this.errors[err.param] = err.msg;
            });
            console.log(this.errors);
          }
          this.stopLoading();
        });
      // this.prodToAdd = {};
    },
  },
  mixins: [loadingMixin],
  props: ["newdialog", "unset", "id", "getInfo"],
};
</script>
<style lang="scss">
.registration-section .main-register {
  display: flex;
  justify-content: space-between;
}
.registration-heading {
  display: flex;
  align-items: center;
}
.registration-section .registration-heading h2 {
  /* color:#6A7784; */
  /* font-size: 20px; */
  font-family: Poppins-Medium;
}
.registration-section .registration-heading span {
  width: 1px;
  height: 30px;
  /* background: #6A7784; */
  margin: 0px 15px;
}
.registration-section .registration-heading p {
  /* color: #97A8B8; */
  font-size: 20px;
  font-family: Poppins-Medium;
}
.registration-btn {
  display: flex;
  align-items: center;
}
.registration-btn.bottom-btn {
  margin: 30px 22px 0px 0px;
  justify-content: flex-end;
  padding: 24px 15px;
  border-top: 1px solid #dae1ec;
  width: 100%;
}
.animal-from.margin-cell-3 {
  margin-top: 20px;
}
.animal-from {
  display: inline;
}
.animal-from label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.form-group span {
  color: red;
}
</style>
